var map = {
	".": "ByCb",
	"./": "ByCb",
	"./01_get_quote_contracts": "lrAs",
	"./01_get_quote_contracts.json": "lrAs",
	"./03_get_quote_depth": "obcS",
	"./03_get_quote_depth.json": "obcS",
	"./04_get_quote_ trades": "KY9U",
	"./04_get_quote_ trades.json": "KY9U",
	"./05_get_quote_ premiumIndex": "5xUh",
	"./05_get_quote_ premiumIndex.json": "5xUh",
	"./06_get_quote_ fundingRate": "dEdI",
	"./06_get_quote_ fundingRate.json": "dEdI",
	"./07_get_quote_ klines": "UTAD",
	"./07_get_quote_ klines.json": "UTAD",
	"./08_get_quote_openInterest": "0IKX",
	"./08_get_quote_openInterest.json": "0IKX",
	"./09_get_quote_ ticker": "Y7KR",
	"./09_get_quote_ ticker.json": "Y7KR",
	"./19_get_historicalTrades": "iQjo",
	"./19_get_historicalTrades.json": "iQjo",
	"./20_get_trade_quote_bookTicker": "1iLz",
	"./20_get_trade_quote_bookTicker.json": "1iLz",
	"./21_get_quote_mark_price_klines": "5vst",
	"./21_get_quote_mark_price_klines.json": "5vst",
	"./22_get_quote_price_v2": "OSRE",
	"./22_get_quote_price_v2.json": "OSRE",
	"./23_get_trading_rules": "gkT4",
	"./23_get_trading_rules.json": "gkT4",
	"./index": "ByCb",
	"./index.js": "ByCb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fKdH";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/market ^.*$
// module id = fKdH
// module chunks = 3